import React from 'react';
import Layout from '../components/Layout';
import '../styles/contact-us.css';

const ContactUs = () => {
  return (
    <Layout>
      <div className="contact-us-container">
        {/* Background image */}
        <div className="contact-background">
          <img src="/Atlas.png" alt="Agent Atlas" className="background-image" />
        </div>
        
        {/* Contact information - fixed position */}
        <div className="contact-info-fixed">
          <h2>Contact Fox River AI</h2>
          <div className="contact-methods">
            <div className="contact-method">
              <strong>📞 Phone:</strong> (630) 940-8837
            </div>
            <div className="contact-method">
              <strong>✉️ Email:</strong> info@relufox.ai
            </div>
            <div className="contact-method">
              <strong>🕒 Hours:</strong> Mon-Fri 9AM-6PM CST
            </div>
          </div>
          <div className="contact-description">
            <p>Ready to transform your business with AI? Let's discuss your project and explore how we can help you achieve your goals.</p>
          </div>
        </div>
      </div>
    </Layout>
  );
};

export default ContactUs;